<template>
    <div class="ui-usage-wrap" :class="{'is-loading': $store.state.is_loading}">
        <div class="ui-usage-large" v-if="is_use_props">
            <h2>
                <span class="text">Creator seats usage</span>
                <tippy :content="((current_creator_count/$store.state.creator_max_count) * 100).toFixed(0) + '% usage'" class="question">
                    <svg-icon name="question" />
                </tippy>
            </h2>
            <div class="bar">
                <span>
                    <i :style="{'width': ((current_creator_count/$store.state.creator_max_count) * 100) + '%'}"></i>
                </span>
                <!-- <i v-if="!$store.state.is_loading && count >= $store.state.creator_max_count">
                    <svg-icon name="warning" />
                </i> -->
                <label>
                    {{ current_creator_count }}/{{ $store.state.creator_max_count }}
                </label>
            </div>
        </div>
        <div class="ui-usage-large" v-else>
            <h2>
                <span class="text">Creator seats usage</span>
                <tippy :content="(($store.state.current_creator_count/$store.state.creator_max_count) * 100).toFixed(0) + '% usage'" class="question">
                    <svg-icon name="question" />
                </tippy>
            </h2>
            <div class="bar">
                <span>
                    <i :style="{'width': (($store.state.current_creator_count/$store.state.creator_max_count) * 100) + '%'}"></i>
                </span>
                <!-- <i v-if="!$store.state.is_loading && $store.state.current_creator_count >= $store.state.creator_max_count">
                    <svg-icon name="warning" />
                </i> -->
                <label>
                    {{ $store.state.current_creator_count }}/{{ $store.state.creator_max_count }}
                </label>
            </div>
        </div>
        <div class="ui-usage-large" v-if="!only_creator">
            <h2>
                <span class="text">Teammates</span>
                <tippy :content="(($store.state.current_portal_user_count/$store.state.portal_user_max_count) * 100).toFixed(0) + '% usage'" class="question">
                    <svg-icon name="question" />
                </tippy>
            </h2>
            <div class="bar">
                <span>
                    <i :style="{'width': (($store.state.current_portal_user_count/$store.state.portal_user_max_count) * 100) + '%'}"></i>
                </span>
                <!-- <i v-if="!$store.state.is_loading && $store.state.current_portal_user_count >= $store.state.portal_user_max_count">
                    <svg-icon name="warning" />
                </i> -->
                <label>
                    {{ $store.state.current_portal_user_count }}/{{ $store.state.portal_user_max_count }}
                </label>
            </div>
        </div>
    </div>
    <p class="ui-usage-text" v-if="!only_creator && canShowPlan">
        <a v-if="$store.state.projectName !== 'cj'"
           :href="`mailto:${$store.state.mail_to}?subject=${$store.state.user_data.merchant_account.merchant_display_name} - Upgrade creator limit&body=Please provide your name and contact info. A representative will contact you in 1-2 business days.`"
           target="_blank">Contact us</a>
        <a v-else href="#" @click.prevent="openSupportForm">Contact us</a>
        to upgrade your plan.</p>
</template>

<script>

export default {
    name: 'usage',

    props: {
        is_use_props: {
            type: Boolean,
            default: false
        },
        current_creator_count: {
            type: Number,
            default: 0
        },
        only_creator: {
            type: Boolean,
            default: false
        },
        canShowPlan: {
            type: Boolean,
            default: true
        }
    },

    methods: {
        openSupportForm() {
            this.EventBus.emit('open-global-drawer', 'help-support');
        },
    },
};
</script>

<style lang="scss">
    .ui-usage-wrap {
        display: flex;

        &.is-loading {
            opacity: .5;
            pointer-events: none;
        }
    }

    .ui-usage-text {
        margin: 12px 0;
        font: var(--font-fg-12);
        color: var(--dark-gray-blue);
    }

    .ui-usage-large {
        padding: 4px 8px;
        background-color: var(--bg-03);
        border-radius: 4px;
        margin-right: 12px;
        min-width: 105px;

        h2 {
            font: var(--font-fg-12);
            margin: 0 0 4px;
            color: var(--dark-blue);
            display: flex;
            align-items: center;

            .text {
                flex: 1;
            }
            
            .question {
                svg {
                    height: 12px;
                    width: 12px;
                    fill: var(--black-75);
                    margin-left: 8px;
                }
            }
        }

        .bar {
            margin: 0;
            position: relative;
            display: flex;
            align-items: center;

            span {
                height: 4px;
                border-radius: 2px;
                background-color: white;
                position: relative;
                overflow: hidden;
                display: block;
                flex: 1;

                i {
                    position: absolute;
                    left: 0;
                    top: 0;
                    height: 100%;
                    background-color: var(--dark-blue);
                    transition: all .3s ease;
                }
            }

            & > i {
                padding-left: 8px;

                & + label {
                    padding-left: 5px;
                }

                svg {
                    height: 12px;
                    width: 12px;
                    fill: var(--alert);
                }
            }

            label {
                font: var(--font-fg-10);
                color: var(--black-90);
                padding-left: 8px;
            }
        }

    }
</style>